import { Go, UsageAltNav } from '@clearkit/icons';
import { CKButton, CKLayoutHorizontal, CKSkeleton } from 'clearkit';
import { Link } from 'react-router-dom';

import { useCreditUsage } from '~/hooks/account/useCreditUsage';

import { HomeHeading } from '../HomeHeading';
import { MeterBox } from '../MeterBox';

const Metric = ({ value }: { value?: string | number | null | undefined }) => (
  <span className="mr-1 font-medium">{value?.toLocaleString('en-us')}</span>
);

export const HomeSidebarUsage = () => {
  const {
    credits,
    creditsUsed,
    hasUsage,
    hasCredits,
    loading,
  } = useCreditUsage();

  if (!hasUsage) {
    return null;
  }

  return (
    <section className="pt-8 space-y-8">
      <CKLayoutHorizontal as="header">
        <HomeHeading>
          <UsageAltNav height={16} width={16} /> Credits & Usage
        </HomeHeading>
        <CKButton
          as={Link}
          rightIcon={<Go />}
          to="/settings/usage"
          variant="tertiary"
          variantColor="blue"
        >
          View Usage
        </CKButton>
      </CKLayoutHorizontal>
      <CKLayoutHorizontal justifyContent="start">
        <MeterBox
          isError={hasCredits && creditsUsed > credits}
          max={!hasCredits ? 1 : credits}
          value={hasCredits ? creditsUsed : 0}
        />
        {hasUsage || loading ? (
          <div className="space-y-1">
            <CKSkeleton
              className="h-6 w-[14ch] ck-skeleton--white"
              isLoading={loading}
              label="loading"
            >
              <p>
                <Metric value={creditsUsed} />
                credits used
              </p>
            </CKSkeleton>
            <CKSkeleton
              className="h-6 w-[16ch] ck-skeleton--white"
              isLoading={loading}
              label="loading"
            >
              <p>
                <Metric value={hasCredits ? credits : 'Unlimited'} />
                credits available
              </p>
            </CKSkeleton>
          </div>
        ) : (
          <div>No Usage Data Available</div>
        )}
      </CKLayoutHorizontal>
    </section>
  );
};
